import React from "react"
import { ModalSeeker } from "@ui-seeker/core"

import { reportListMultipleData } from "../../@signals"
import ReportListMultipleModalContent from "./Content"
import { useComputed } from "@preact/signals-react"


export default function ReportListMultipleModal() {

	const isOpenModal = useComputed(() => !!reportListMultipleData.value?.key)

	return <ModalSeeker
		containerProps={{ maxWidth: "md" }}
		controller={() => reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }}
		isOpen={isOpenModal.value}
		hideActions
	>
		<ReportListMultipleModalContent/>
	</ModalSeeker>
}